import { engine } from '@play-co/timestep-core';
import { Container, Sprite } from '../../../odie';
import { CubeBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

const assets = {
  lollipop: 'power/block.cube.super.png',
  shine: 'fx.cube/fx.cube.shine.png',
};

export class SuperCubeBlockView extends Container {
  private shine1: Sprite;
  private shine2: Sprite;
  private lollipop: FitWidthBlockSprite;

  constructor(props?: CubeBlockProps) {
    super();

    if (!props) {
      props = { id: 'cube', type: 'cube', color: 'all' };
    }

    this.shine1 = new Sprite(assets.shine);
    this.shine1.anchorX = this.shine1.anchorY = 0.5;
    this.shine1.scaleX = this.shine1.scaleY = 0.7;
    this.addChild(this.shine1);

    this.shine2 = new Sprite(assets.shine);
    this.shine2.anchorX = this.shine2.anchorY = 0.5;
    this.shine2.scaleX = this.shine2.scaleY = 0.7;
    this.addChild(this.shine2);

    this.lollipop = new FitWidthBlockSprite(assets.lollipop, props);
    this.lollipop.y += 2;
    this.addChild(this.lollipop);

    blockPositionView(this, props);

    this.view.setTick(this.tick);
  }

  private tick = (dt: number) => {
    this.shine1.rotation += dt * 0.001;
    this.shine2.rotation -= dt * 0.0013;
    this.lollipop.rotation = Math.sin(performance.now() * 0.004) * 0.2;
  };

  public static assets(): string[] {
    return Object.values(assets).map((asset) => getMatch2AssetPath(asset));
  }
}
